'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimilarItemsMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _mockData = require('./mockData');

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimilarItemsMock = exports.SimilarItemsMock = {
    fetchSimilarItemsById: function fetchSimilarItemsById(itemId) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var similarItemIds = _mockData.mockSimilarItems.filter(function (x) {
                    return x.itemId === itemId;
                });
                var items = similarItemIds[0].similarItems.map(function (x) {
                    return (0, _mockData.getTestItem)(x);
                });
                var biddingInfos = [];
                var bidIncrements = [];
                var catalogs = [];
                var sellers = [];

                items.forEach(function (item) {
                    biddingInfos = (0, _union2.default)(biddingInfos, [(0, _mockData.getTestBiddingInfoForItem)(item.itemId)]);
                    bidIncrements = (0, _union2.default)(bidIncrements, [(0, _mockData.getTestBidIncrementForCatalog)(item.catalogId)]);
                    catalogs = (0, _union2.default)(catalogs, [(0, _mockData.getTestCatalog)(item.catalogId)]);
                    sellers = (0, _union2.default)(sellers, [(0, _mockData.getTestSeller)(item.sellerId)]);
                });
                resolve({
                    data: {
                        biddingInfos: biddingInfos,
                        bidIncrements: bidIncrements,
                        catalogs: catalogs,
                        items: items,
                        sellers: sellers
                    }
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/similarItems.js
// module id = RB4q
// module chunks = 46